export default __webpack_public_path__ + "static/media/017-badminton.47d115e8.svg";